const __WEBPACK_NAMESPACE_OBJECT__ = require("cep-webpack-plugin");;